module.exports = __webpack_public_path__ + "img/w3.4ae3de8a.jpg";